define('viewModels/privileged/base/BaseStateMachine',[
    'viewModels/ViewModel',
    'lib/knockout',
    'lib/lodash4'
], function (ViewModel, ko, _) {
    'use strict';

    // This is a pattern for invoking a constructor with a dynamic list of arguments.
    // http://stackoverflow.com/questions/1606797/use-of-apply-with-new-operator-is-this-possible
    function construct(constructor, args) {
        function F() {
            return constructor.apply(this, args);
        }
        F.prototype = constructor.prototype;
        return new F();
    }

    /**
     * The BaseStateMachine is a ViewModel that implements the State pattern.
     *
     * When a ViewModel has several states and each state shares a reasonably similar set of logical operations, but
     * different strategies for each operation, the finite state machine is one way to organize the logic without a lot
     * of unmaintainable conditionals.
     *
     */
    var BaseStateMachine  = ViewModel.extend(function () {
        var self = this;
        var state = ko.observable(null);
        var states = {};

        self.getState = self.computed(function () {
            return state();
        });

        self.transitionTo = function (newState) {
            var args = Array.prototype.slice.call(arguments, 1); // Any additional arguments to pass to the new state.
            args.unshift(self); // Always pass a reference to the FSM as the first argument.

            var StateConstructor = states[newState];
            if (StateConstructor) {
                var instance = construct(StateConstructor, args);

                if (instance) {

                    // Update all the properties on the FSM to the correct strategy.
                    _.each(instance, function(value, key) {

                        // Be careful to update observables instead of replace them. Templates may be bound to them.
                        if (self[key] && ko.isObservable(self[key])) {
                            if(ko.isWritableObservable(self[key])) {
                                self[key](ko.unwrap(instance[key]));
                            }
                        }
                        else {
                            self[key] = instance[key]; // Replace non-observable values.
                        }
                    });

                    // Now update the FSM state.
                    state(newState);

                    return true;
                }
            }

            return false;
        };

        self.registerState = function (stateName, Constructor) {
            states[stateName] = Constructor;
        };

        self.isReady = self.computed(function () {
            return state() !== null;
        });
    });

    return BaseStateMachine;

});

